import { type JSX } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import Banner from '@/shared/components/Banner';
import { Footer } from '@/shared/components/Footer';
import Navbar from './Navbar';
import { PAGE_TITLES } from '../../utils/seo';

export const Layout = ({
  children,
  className,
  title,
}: {
  children?: JSX.Element[] | JSX.Element | string;
  className?: string;
  title: string;
}): JSX.Element => {
  const router = useRouter();
  const fullTitle =
    PAGE_TITLES[router.pathname] ?? [title, 'Chainflip Auctions'].filter(Boolean).join(' | ');

  return (
    <div className={classNames('flex min-h-screen flex-col items-center', className)}>
      <Head>
        <title>{fullTitle}</title>
        <meta property="og:title" content={fullTitle} key="title" />
      </Head>
      <Banner app="STAKE" />
      <Navbar />
      <div className="flex min-h-full w-full flex-1 flex-col p-4 2xl:container md:px-8 md:py-5 lg:pt-5">
        {children}
      </div>
      <Footer app="auctions" />
    </div>
  );
};
